export const SubRoutes = {
  REGISTRATION: {
    complete: 'complete',
    profile: 'profile',
  } as const,
  ORGANIZATIONS: {
    pick: 'pick',
  } as const,
  SETTINGS: {
    account: 'account',
    subscription: 'subscription',
    caching: 'caching',
  } as const,
  REPORTS: {
    catalog: 'catalog',
    copilot: 'copilot',
  } as const,
  NARRATIVE_INTELLIGENCE: {
    narratives: 'narratives',
    networks: 'networks',
    // sources: 'sources',
    supplyCain: 'supply-chain',
  } as const,
  GEOPOLITICAL_INTELLIGENCE: {
    incidents: 'incidents',
    trade: 'trade',
    actions: 'actions',
  } as const,
};

export const Routes = {
  /** Error page */
  AUTH_ERROR: '/auth/error',

  /** Registration pages */
  REGISTRATION: '/registration',
  REGISTRATION_PROFILE: `/registration/${SubRoutes.REGISTRATION.profile}`,
  REGISTRATION_COMPLETE: `/registration/${SubRoutes.REGISTRATION.complete}`,
  REGISTRATION_VERIFY_EMAIL: '/registration/verify-email',

  /** Organization picker flow */
  ORGANIZATIONS: '/organizations',
  ORGANIZATIONS_PICK: `/organizations/${SubRoutes.ORGANIZATIONS.pick}`,

  /** General */
  INDEX: '/',
  DASHBOARD: '/dashboard',
  INCIDENTS: '/incidents',
  SEARCH_CONSOLE: '/search-console',

  SETTINGS: '/settings',
  SETTINGS_ACCOUNT: `/settings/${SubRoutes.SETTINGS.account}`,
  SETTINGS_SUBSCRIPTION: `/settings/${SubRoutes.SETTINGS.subscription}`,
  SETTINGS_CACHE: `/settings/${SubRoutes.SETTINGS.caching}`,

  /** Geopolitical Intelligence */
  GEOPOLITICAL_INTELLIGENCE: '/geopolitical-intelligence',
  GEOPOLITICAL_INTELLIGENCE_INCIDENTS: `/geopolitical-intelligence/${SubRoutes.GEOPOLITICAL_INTELLIGENCE.incidents}`,
  GEOPOLITICAL_INTELLIGENCE_TRADE: `/geopolitical-intelligence/${SubRoutes.GEOPOLITICAL_INTELLIGENCE.trade}`,
  GEOPOLITICAL_INTELLIGENCE_ACTIONS: `/geopolitical-intelligence/${SubRoutes.GEOPOLITICAL_INTELLIGENCE.actions}`,

  /** Reports pages */
  REPORTS: '/reports',
  REPORTS_CATALOG: `/reports/${SubRoutes.REPORTS.catalog}`,
  REPORTS_COPILOT: `/reports/${SubRoutes.REPORTS.copilot}`,

  /** Narrative Intelligence pages */
  NARRATIVE_INTELLIGENCE: '/narrative-intelligence',
  NARRATIVE_INTELLIGENCE_NARRATIVES: `/narrative-intelligence/${SubRoutes.NARRATIVE_INTELLIGENCE.narratives}`,
  NARRATIVE_INTELLIGENCE_NETWORKS: `/narrative-intelligence/${SubRoutes.NARRATIVE_INTELLIGENCE.networks}`,

  /** Supply Chain pages */
  SUPPLY_CHAIN: '/supply-chain',

  /** Embedded pages apps */
  EMBEDDED_SUPPLY_CHAIN: '/embedded/supply-chain',
  EMBEDDED_INTELLIGENCE_DASHBOARD: '/embedded/intelligence-dashboard',
  // TEMP(ankara-poc-demo): Ankara NATO POC demo — remove after the demo.
  EMBEDDED_ANKARA_POC: '/embedded/ankara-poc',

  /** Legal info */
  LEGAL_TERMS_OF_SERVICE: '/legal/terms',
  LEGAL_PRIVACY_POLICY: '/legal/privacy',
} as const;

export type PageHref = ValueOf<typeof Routes>;

export type RegistrationSubRoutes = ValueOf<typeof SubRoutes.REGISTRATION>;

export type SettingsSubRoutes = ValueOf<typeof SubRoutes.SETTINGS>;

export type OrganizationsSubRoutes = ValueOf<typeof SubRoutes.ORGANIZATIONS>;

export type ReportSubRoutes = ValueOf<typeof SubRoutes.REPORTS>;

export type NarrativeSubRoutes = ValueOf<typeof SubRoutes.NARRATIVE_INTELLIGENCE>;

export type GeopoliticalSubRoutes = ValueOf<typeof SubRoutes.GEOPOLITICAL_INTELLIGENCE>;
